import React from "react";
import { View, Text, StyleSheet } from "react-native";

export function EmptyItemsState() {
  return (
    <View style={styles.wrap}>
      <Text style={styles.title}>No items added yet</Text>
      <Text style={styles.sub}>
        Add at least one product or service to continue.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    paddingVertical: 18,
    paddingHorizontal: 16,
    borderRadius: 14,
    backgroundColor: "#F9FAFB",
    borderWidth: 1,
    borderColor: "#E5E7EB",
  },
  title: {
    color: "#111827",
    fontSize: 16,
    fontWeight: "700",
  },
  sub: {
    marginTop: 6,
    color: "#6B7280",
    fontSize: 13,
    lineHeight: 18,
  },
});